var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发送优惠券包",
            visible: _vm.dialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: { model: _vm.form, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "选择券包：",
                    prop: "packageIds",
                    rules: [
                      {
                        required: true,
                        message: "请选择券包",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        placeholder: "请选择券包",
                      },
                      on: { focus: _vm.loadPackages },
                      model: {
                        value: _vm.form.packageIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "packageIds", $$v)
                        },
                        expression: "form.packageIds",
                      },
                    },
                    [
                      _vm._l(_vm.packageOptions, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: item.id + " - " + item.packageName,
                            value: item.id,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _vm.hasMorePackages
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                padding: "5px 0",
                                "text-align": "center",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.loadMorePackages },
                                },
                                [_vm._v("加载更多")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c("div", { staticClass: "selected-info" }, [
                  _vm._v("\n          已选择 "),
                  _c("span", { staticClass: "highlight" }, [
                    _vm._v(_vm._s(_vm.employeeData.employees.length)),
                  ]),
                  _vm._v(" 名员工\n        "),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.submit },
                },
                [_vm._v("确定发送")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }